__turbopack_context__.v({
  "action": "NotificationList-module__hpDB9q__action",
  "body": "NotificationList-module__hpDB9q__body",
  "chip": "NotificationList-module__hpDB9q__chip",
  "content": "NotificationList-module__hpDB9q__content",
  "contentRow": "NotificationList-module__hpDB9q__contentRow",
  "date": "NotificationList-module__hpDB9q__date",
  "emptyState": "NotificationList-module__hpDB9q__emptyState",
  "iconCircle": "NotificationList-module__hpDB9q__iconCircle",
  "kebabBtn": "NotificationList-module__hpDB9q__kebabBtn",
  "kebabMenu": "NotificationList-module__hpDB9q__kebabMenu",
  "kebabMenuItem": "NotificationList-module__hpDB9q__kebabMenuItem",
  "kebabMenuItemDestructive": "NotificationList-module__hpDB9q__kebabMenuItemDestructive",
  "kebabWrap": "NotificationList-module__hpDB9q__kebabWrap",
  "list": "NotificationList-module__hpDB9q__list",
  "meta": "NotificationList-module__hpDB9q__meta",
  "readAt": "NotificationList-module__hpDB9q__readAt",
  "row": "NotificationList-module__hpDB9q__row",
  "showAllContainer": "NotificationList-module__hpDB9q__showAllContainer",
  "unread": "NotificationList-module__hpDB9q__unread",
});
